export const GET_PRODUCTS_DATA_START   = "GET_PRODUCTS_DATA_START"
export const GET_PRODUCTS_DATA_SUCCESS = "GET_PRODUCTS_DATA_SUCCESS"
export const GET_PRODUCTS_DATA_ERROR   = "GET_PRODUCTS_DATA_ERROR"

// ── Auth ────────────────────────────────────────────────────────────────
export const SIGNUP_START   = "SIGNUP_START"
export const SIGNUP_SUCCESS = "SIGNUP_SUCCESS"
export const SIGNUP_ERROR   = "SIGNUP_ERROR"

export const VERIFY_OTP_START   = "VERIFY_OTP_START"
export const VERIFY_OTP_SUCCESS = "VERIFY_OTP_SUCCESS"
export const VERIFY_OTP_ERROR   = "VERIFY_OTP_ERROR"

export const RESEND_OTP_START   = "RESEND_OTP_START"
export const RESEND_OTP_SUCCESS = "RESEND_OTP_SUCCESS"
export const RESEND_OTP_ERROR   = "RESEND_OTP_ERROR"

export const SELECT_ROLE_START   = "SELECT_ROLE_START"
export const SELECT_ROLE_SUCCESS = "SELECT_ROLE_SUCCESS"
export const SELECT_ROLE_ERROR   = "SELECT_ROLE_ERROR"

export const LOGIN_START   = "LOGIN_START"
export const LOGIN_SUCCESS = "LOGIN_SUCCESS"
export const LOGIN_ERROR   = "LOGIN_ERROR"

export const LOGOUT = "LOGOUT"

export const GET_ME_START        = "GET_ME_START"
export const GET_ME_SUCCESS      = "GET_ME_SUCCESS"
export const GET_ME_ERROR        = "GET_ME_ERROR"
export const UPDATE_KYC_STATUS   = "UPDATE_KYC_STATUS"

// ── Onboarding ──────────────────────────────────────────────────────────
export const ONBOARD_CREATOR_START   = "ONBOARD_CREATOR_START"
export const ONBOARD_CREATOR_SUCCESS = "ONBOARD_CREATOR_SUCCESS"
export const ONBOARD_CREATOR_ERROR   = "ONBOARD_CREATOR_ERROR"

export const ONBOARD_BRAND_START   = "ONBOARD_BRAND_START"
export const ONBOARD_BRAND_SUCCESS = "ONBOARD_BRAND_SUCCESS"
export const ONBOARD_BRAND_ERROR   = "ONBOARD_BRAND_ERROR"

export const ONBOARD_AGENCY_START   = "ONBOARD_AGENCY_START"
export const ONBOARD_AGENCY_SUCCESS = "ONBOARD_AGENCY_SUCCESS"
export const ONBOARD_AGENCY_ERROR   = "ONBOARD_AGENCY_ERROR"

export const KYC_START   = "KYC_START"
export const KYC_SUCCESS = "KYC_SUCCESS"
export const KYC_ERROR   = "KYC_ERROR"

// ── Discovery ────────────────────────────────────────────────────────────
export const FETCH_CREATORS_START   = "FETCH_CREATORS_START"
export const FETCH_CREATORS_SUCCESS = "FETCH_CREATORS_SUCCESS"
export const FETCH_CREATORS_ERROR   = "FETCH_CREATORS_ERROR"

export const FETCH_CREATOR_DETAIL_START   = "FETCH_CREATOR_DETAIL_START"
export const FETCH_CREATOR_DETAIL_SUCCESS = "FETCH_CREATOR_DETAIL_SUCCESS"
export const FETCH_CREATOR_DETAIL_ERROR   = "FETCH_CREATOR_DETAIL_ERROR"

export const FETCH_AGENCIES_START   = "FETCH_AGENCIES_START"
export const FETCH_AGENCIES_SUCCESS = "FETCH_AGENCIES_SUCCESS"
export const FETCH_AGENCIES_ERROR   = "FETCH_AGENCIES_ERROR"

export const FETCH_AGENCY_DETAIL_START   = "FETCH_AGENCY_DETAIL_START"
export const FETCH_AGENCY_DETAIL_SUCCESS = "FETCH_AGENCY_DETAIL_SUCCESS"
export const FETCH_AGENCY_DETAIL_ERROR   = "FETCH_AGENCY_DETAIL_ERROR"

export const FETCH_BRAND_DETAIL_START   = "FETCH_BRAND_DETAIL_START"
export const FETCH_BRAND_DETAIL_SUCCESS = "FETCH_BRAND_DETAIL_SUCCESS"
export const FETCH_BRAND_DETAIL_ERROR   = "FETCH_BRAND_DETAIL_ERROR"

export const FETCH_SAVED_PROFILES_START   = "FETCH_SAVED_PROFILES_START"
export const FETCH_SAVED_PROFILES_SUCCESS = "FETCH_SAVED_PROFILES_SUCCESS"
export const FETCH_SAVED_PROFILES_ERROR   = "FETCH_SAVED_PROFILES_ERROR"

export const TOGGLE_SAVE_PROFILE_SUCCESS  = "TOGGLE_SAVE_PROFILE_SUCCESS"

export const FETCH_SHORTLISTS_START       = "FETCH_SHORTLISTS_START"
export const FETCH_SHORTLISTS_SUCCESS     = "FETCH_SHORTLISTS_SUCCESS"
export const FETCH_SHORTLISTS_ERROR       = "FETCH_SHORTLISTS_ERROR"

export const CREATE_SHORTLIST_SUCCESS     = "CREATE_SHORTLIST_SUCCESS"
export const DELETE_SHORTLIST_SUCCESS     = "DELETE_SHORTLIST_SUCCESS"
export const UPDATE_SHORTLIST_ITEMS_SUCCESS = "UPDATE_SHORTLIST_ITEMS_SUCCESS"

// ── Campaigns ────────────────────────────────────────────────────────────────
export const FETCH_CAMPAIGNS_START   = "FETCH_CAMPAIGNS_START"
export const FETCH_CAMPAIGNS_SUCCESS = "FETCH_CAMPAIGNS_SUCCESS"
export const FETCH_CAMPAIGNS_ERROR   = "FETCH_CAMPAIGNS_ERROR"

export const FETCH_CAMPAIGN_DETAIL_START   = "FETCH_CAMPAIGN_DETAIL_START"
export const FETCH_CAMPAIGN_DETAIL_SUCCESS = "FETCH_CAMPAIGN_DETAIL_SUCCESS"
export const FETCH_CAMPAIGN_DETAIL_ERROR   = "FETCH_CAMPAIGN_DETAIL_ERROR"

export const CREATE_CAMPAIGN_START   = "CREATE_CAMPAIGN_START"
export const CREATE_CAMPAIGN_SUCCESS = "CREATE_CAMPAIGN_SUCCESS"
export const CREATE_CAMPAIGN_ERROR   = "CREATE_CAMPAIGN_ERROR"

export const UPDATE_CAMPAIGN_START   = "UPDATE_CAMPAIGN_START"
export const UPDATE_CAMPAIGN_SUCCESS = "UPDATE_CAMPAIGN_SUCCESS"
export const UPDATE_CAMPAIGN_ERROR   = "UPDATE_CAMPAIGN_ERROR"

export const CANCEL_CAMPAIGN_START   = "CANCEL_CAMPAIGN_START"
export const CANCEL_CAMPAIGN_SUCCESS = "CANCEL_CAMPAIGN_SUCCESS"
export const CANCEL_CAMPAIGN_ERROR   = "CANCEL_CAMPAIGN_ERROR"
export const CANCEL_CREATORS_START   = "CANCEL_CREATORS_START"
export const CANCEL_CREATORS_SUCCESS = "CANCEL_CREATORS_SUCCESS"
export const CANCEL_CREATORS_ERROR   = "CANCEL_CREATORS_ERROR"

export const DELETE_CAMPAIGN_START   = "DELETE_CAMPAIGN_START"
export const DELETE_CAMPAIGN_SUCCESS = "DELETE_CAMPAIGN_SUCCESS"
export const DELETE_CAMPAIGN_ERROR   = "DELETE_CAMPAIGN_ERROR"

// ── Proposals ────────────────────────────────────────────────────────────────
export const FETCH_PROPOSALS_START   = "FETCH_PROPOSALS_START"
export const FETCH_PROPOSALS_SUCCESS = "FETCH_PROPOSALS_SUCCESS"
export const FETCH_PROPOSALS_ERROR   = "FETCH_PROPOSALS_ERROR"

export const SUBMIT_PROPOSAL_START   = "SUBMIT_PROPOSAL_START"
export const SUBMIT_PROPOSAL_SUCCESS = "SUBMIT_PROPOSAL_SUCCESS"
export const SUBMIT_PROPOSAL_ERROR   = "SUBMIT_PROPOSAL_ERROR"

export const ACCEPT_INVITE_START   = "ACCEPT_INVITE_START"
export const ACCEPT_INVITE_SUCCESS = "ACCEPT_INVITE_SUCCESS"
export const ACCEPT_INVITE_ERROR   = "ACCEPT_INVITE_ERROR"

export const UPDATE_PROPOSAL_START   = "UPDATE_PROPOSAL_START"
export const UPDATE_PROPOSAL_SUCCESS = "UPDATE_PROPOSAL_SUCCESS"
export const UPDATE_PROPOSAL_ERROR   = "UPDATE_PROPOSAL_ERROR"

export const FETCH_MY_PROPOSALS_START   = "FETCH_MY_PROPOSALS_START"
export const FETCH_MY_PROPOSALS_SUCCESS = "FETCH_MY_PROPOSALS_SUCCESS"
export const FETCH_MY_PROPOSALS_ERROR   = "FETCH_MY_PROPOSALS_ERROR"
// ── Daily Application Limit ────────────────────────────────────────────
export const FETCH_DAILY_BID_USAGE_START   = "FETCH_DAILY_BID_USAGE_START"
export const FETCH_DAILY_BID_USAGE_SUCCESS = "FETCH_DAILY_BID_USAGE_SUCCESS"
export const FETCH_DAILY_BID_USAGE_ERROR   = "FETCH_DAILY_BID_USAGE_ERROR"

// ── Notifications ─────────────────────────────────────────────────────────────
export const FETCH_NOTIFICATIONS_START   = "FETCH_NOTIFICATIONS_START"
export const FETCH_NOTIFICATIONS_SUCCESS = "FETCH_NOTIFICATIONS_SUCCESS"
export const FETCH_NOTIFICATIONS_ERROR   = "FETCH_NOTIFICATIONS_ERROR"

export const MARK_NOTIFICATION_READ_SUCCESS = "MARK_NOTIFICATION_READ_SUCCESS"
export const MARK_ALL_NOTIFICATIONS_READ    = "MARK_ALL_NOTIFICATIONS_READ"

// ── Milestones ────────────────────────────────────────────────────────────────
export const FETCH_MILESTONES_START   = "FETCH_MILESTONES_START"
export const FETCH_MILESTONES_SUCCESS = "FETCH_MILESTONES_SUCCESS"
export const FETCH_MILESTONES_ERROR   = "FETCH_MILESTONES_ERROR"

export const CREATE_MILESTONE_START   = "CREATE_MILESTONE_START"
export const CREATE_MILESTONE_SUCCESS = "CREATE_MILESTONE_SUCCESS"
export const CREATE_MILESTONE_ERROR   = "CREATE_MILESTONE_ERROR"

export const UPDATE_MILESTONE_START   = "UPDATE_MILESTONE_START"
export const UPDATE_MILESTONE_SUCCESS = "UPDATE_MILESTONE_SUCCESS"
export const UPDATE_MILESTONE_ERROR   = "UPDATE_MILESTONE_ERROR"

export const DELETE_MILESTONE_START   = "DELETE_MILESTONE_START"
export const DELETE_MILESTONE_SUCCESS = "DELETE_MILESTONE_SUCCESS"
export const DELETE_MILESTONE_ERROR   = "DELETE_MILESTONE_ERROR"

export const SUBMIT_MILESTONE_START   = "SUBMIT_MILESTONE_START"
export const SUBMIT_MILESTONE_SUCCESS = "SUBMIT_MILESTONE_SUCCESS"
export const SUBMIT_MILESTONE_ERROR   = "SUBMIT_MILESTONE_ERROR"

export const REVIEW_SUBMISSION_START   = "REVIEW_SUBMISSION_START"
export const REVIEW_SUBMISSION_SUCCESS = "REVIEW_SUBMISSION_SUCCESS"
export const REVIEW_SUBMISSION_ERROR   = "REVIEW_SUBMISSION_ERROR"

// ── Messaging ─────────────────────────────────────────────────────────────────
export const FETCH_CONVERSATIONS_START   = "FETCH_CONVERSATIONS_START"
export const FETCH_CONVERSATIONS_SUCCESS = "FETCH_CONVERSATIONS_SUCCESS"
export const FETCH_CONVERSATIONS_ERROR   = "FETCH_CONVERSATIONS_ERROR"

export const FETCH_MESSAGES_START   = "FETCH_MESSAGES_START"
export const FETCH_MESSAGES_SUCCESS = "FETCH_MESSAGES_SUCCESS"
export const FETCH_MESSAGES_ERROR   = "FETCH_MESSAGES_ERROR"

export const SEND_MESSAGE_SUCCESS        = "SEND_MESSAGE_SUCCESS"
export const CREATE_CONVERSATION_SUCCESS = "CREATE_CONVERSATION_SUCCESS"
export const SET_TOTAL_UNREAD            = "SET_TOTAL_UNREAD"

// ── Wallet ────────────────────────────────────────────────────────────────────
export const FETCH_WALLET_START   = "FETCH_WALLET_START"
export const FETCH_WALLET_SUCCESS = "FETCH_WALLET_SUCCESS"
export const FETCH_WALLET_ERROR   = "FETCH_WALLET_ERROR"

export const WALLET_WITHDRAW_START   = "WALLET_WITHDRAW_START"
export const WALLET_WITHDRAW_SUCCESS = "WALLET_WITHDRAW_SUCCESS"
export const WALLET_WITHDRAW_ERROR   = "WALLET_WITHDRAW_ERROR"

// ── Agency ────────────────────────────────────────────────────────────────────
export const FETCH_AGENCY_CREATORS_START   = "FETCH_AGENCY_CREATORS_START"
export const FETCH_AGENCY_CREATORS_SUCCESS = "FETCH_AGENCY_CREATORS_SUCCESS"
export const FETCH_AGENCY_CREATORS_ERROR   = "FETCH_AGENCY_CREATORS_ERROR"

export const FETCH_AGENCY_INVITATIONS_START   = "FETCH_AGENCY_INVITATIONS_START"
export const FETCH_AGENCY_INVITATIONS_SUCCESS = "FETCH_AGENCY_INVITATIONS_SUCCESS"
export const FETCH_AGENCY_INVITATIONS_ERROR   = "FETCH_AGENCY_INVITATIONS_ERROR"

export const SEND_INVITATION_START   = "SEND_INVITATION_START"
export const SEND_INVITATION_SUCCESS = "SEND_INVITATION_SUCCESS"
export const SEND_INVITATION_ERROR   = "SEND_INVITATION_ERROR"

export const REMOVE_ROSTER_CREATOR_START   = "REMOVE_ROSTER_CREATOR_START"
export const REMOVE_ROSTER_CREATOR_SUCCESS = "REMOVE_ROSTER_CREATOR_SUCCESS"
export const REMOVE_ROSTER_CREATOR_ERROR   = "REMOVE_ROSTER_CREATOR_ERROR"

export const CANCEL_AGENCY_INVITE_START   = "CANCEL_AGENCY_INVITE_START"
export const CANCEL_AGENCY_INVITE_SUCCESS = "CANCEL_AGENCY_INVITE_SUCCESS"
export const CANCEL_AGENCY_INVITE_ERROR   = "CANCEL_AGENCY_INVITE_ERROR"

// ── Creator: agency-assigned work ────────────────────────────────────────────
export const FETCH_MY_ASSIGNMENTS_START   = "FETCH_MY_ASSIGNMENTS_START"
export const FETCH_MY_ASSIGNMENTS_SUCCESS = "FETCH_MY_ASSIGNMENTS_SUCCESS"
export const FETCH_MY_ASSIGNMENTS_ERROR   = "FETCH_MY_ASSIGNMENTS_ERROR"

export const SUBMIT_MY_ASSIGNMENT_START   = "SUBMIT_MY_ASSIGNMENT_START"
export const SUBMIT_MY_ASSIGNMENT_SUCCESS = "SUBMIT_MY_ASSIGNMENT_SUCCESS"
export const SUBMIT_MY_ASSIGNMENT_ERROR   = "SUBMIT_MY_ASSIGNMENT_ERROR"

// ── Agency Campaign Assignments ───────────────────────────────────────────────
export const FETCH_CAMPAIGN_ASSIGNMENTS_START   = "FETCH_CAMPAIGN_ASSIGNMENTS_START"
export const FETCH_CAMPAIGN_ASSIGNMENTS_SUCCESS = "FETCH_CAMPAIGN_ASSIGNMENTS_SUCCESS"
export const FETCH_CAMPAIGN_ASSIGNMENTS_ERROR   = "FETCH_CAMPAIGN_ASSIGNMENTS_ERROR"

export const SAVE_CAMPAIGN_ASSIGNMENTS_START   = "SAVE_CAMPAIGN_ASSIGNMENTS_START"
export const SAVE_CAMPAIGN_ASSIGNMENTS_SUCCESS = "SAVE_CAMPAIGN_ASSIGNMENTS_SUCCESS"
export const SAVE_CAMPAIGN_ASSIGNMENTS_ERROR   = "SAVE_CAMPAIGN_ASSIGNMENTS_ERROR"

export const REVIEW_ASSIGNMENT_START   = "REVIEW_ASSIGNMENT_START"
export const REVIEW_ASSIGNMENT_SUCCESS = "REVIEW_ASSIGNMENT_SUCCESS"
export const REVIEW_ASSIGNMENT_ERROR   = "REVIEW_ASSIGNMENT_ERROR"

export const SUBMIT_TO_BRAND_START   = "SUBMIT_TO_BRAND_START"
export const SUBMIT_TO_BRAND_SUCCESS = "SUBMIT_TO_BRAND_SUCCESS"
export const SUBMIT_TO_BRAND_ERROR   = "SUBMIT_TO_BRAND_ERROR"

// ── Campaign Deliverables ─────────────────────────────────────────────────────
export const FETCH_CAMPAIGN_DELIVERABLES_START   = "FETCH_CAMPAIGN_DELIVERABLES_START"
export const FETCH_CAMPAIGN_DELIVERABLES_SUCCESS = "FETCH_CAMPAIGN_DELIVERABLES_SUCCESS"
export const FETCH_CAMPAIGN_DELIVERABLES_ERROR   = "FETCH_CAMPAIGN_DELIVERABLES_ERROR"

export const ASSIGN_DELIVERABLE_START   = "ASSIGN_DELIVERABLE_START"
export const ASSIGN_DELIVERABLE_SUCCESS = "ASSIGN_DELIVERABLE_SUCCESS"
export const ASSIGN_DELIVERABLE_ERROR   = "ASSIGN_DELIVERABLE_ERROR"

export const REVIEW_DELIVERABLE_START   = "REVIEW_DELIVERABLE_START"
export const REVIEW_DELIVERABLE_SUCCESS = "REVIEW_DELIVERABLE_SUCCESS"
export const REVIEW_DELIVERABLE_ERROR   = "REVIEW_DELIVERABLE_ERROR"

export const SUBMIT_ALL_TO_BRAND_START   = "SUBMIT_ALL_TO_BRAND_START"
export const SUBMIT_ALL_TO_BRAND_SUCCESS = "SUBMIT_ALL_TO_BRAND_SUCCESS"
export const SUBMIT_ALL_TO_BRAND_ERROR   = "SUBMIT_ALL_TO_BRAND_ERROR"

export const FETCH_MY_DELIVERABLES_START   = "FETCH_MY_DELIVERABLES_START"
export const FETCH_MY_DELIVERABLES_SUCCESS = "FETCH_MY_DELIVERABLES_SUCCESS"
export const FETCH_MY_DELIVERABLES_ERROR   = "FETCH_MY_DELIVERABLES_ERROR"

export const SUBMIT_MY_DELIVERABLE_START   = "SUBMIT_MY_DELIVERABLE_START"
export const SUBMIT_MY_DELIVERABLE_SUCCESS = "SUBMIT_MY_DELIVERABLE_SUCCESS"
export const SUBMIT_MY_DELIVERABLE_ERROR   = "SUBMIT_MY_DELIVERABLE_ERROR"

export const FETCH_BRAND_DELIVERABLES_START   = "FETCH_BRAND_DELIVERABLES_START"
export const FETCH_BRAND_DELIVERABLES_SUCCESS = "FETCH_BRAND_DELIVERABLES_SUCCESS"
export const FETCH_BRAND_DELIVERABLES_ERROR   = "FETCH_BRAND_DELIVERABLES_ERROR"

export const BRAND_REVIEW_DELIVERABLE_START   = "BRAND_REVIEW_DELIVERABLE_START"
export const BRAND_REVIEW_DELIVERABLE_SUCCESS = "BRAND_REVIEW_DELIVERABLE_SUCCESS"
export const BRAND_REVIEW_DELIVERABLE_ERROR   = "BRAND_REVIEW_DELIVERABLE_ERROR"

// ── Real-time campaign feed (WebSocket push) ──────────────────────────────────
export const CAMPAIGN_FEED_PUSH  = 'CAMPAIGN_FEED_PUSH'   // prepend incoming campaign
export const CAMPAIGN_CLEAR_NEW  = 'CAMPAIGN_CLEAR_NEW'   // remove _isNew highlight

// ── Real-time notifications (WebSocket push) ──────────────────────────────────
export const NOTIFICATION_PUSH   = 'NOTIFICATION_PUSH'    // prepend incoming notification

// ── Settings / Profile ────────────────────────────────────────────────────────
export const FETCH_PROFILE_START    = "FETCH_PROFILE_START"
export const FETCH_PROFILE_SUCCESS  = "FETCH_PROFILE_SUCCESS"
export const FETCH_PROFILE_ERROR    = "FETCH_PROFILE_ERROR"
export const UPDATE_PROFILE_SUCCESS = "UPDATE_PROFILE_SUCCESS"
export const UPLOAD_AVATAR_SUCCESS  = "UPLOAD_AVATAR_SUCCESS"
export const UPLOAD_COVER_SUCCESS   = "UPLOAD_COVER_SUCCESS"

// ── Creator Analytics ─────────────────────────────────────────────────────────
export const FETCH_MY_ANALYTICS_START   = "FETCH_MY_ANALYTICS_START"
export const FETCH_MY_ANALYTICS_SUCCESS = "FETCH_MY_ANALYTICS_SUCCESS"
export const FETCH_MY_ANALYTICS_ERROR   = "FETCH_MY_ANALYTICS_ERROR"

// ── Notification Preferences ──────────────────────────────────────────────────
export const FETCH_NOTIF_PREFS_SUCCESS  = "FETCH_NOTIF_PREFS_SUCCESS"
export const UPDATE_NOTIF_PREFS_SUCCESS = "UPDATE_NOTIF_PREFS_SUCCESS"

// ── Password Reset ────────────────────────────────────────────────────────────
export const FORGOT_PASSWORD_START   = "FORGOT_PASSWORD_START"
export const FORGOT_PASSWORD_SUCCESS = "FORGOT_PASSWORD_SUCCESS"
export const FORGOT_PASSWORD_ERROR   = "FORGOT_PASSWORD_ERROR"
export const RESET_PASSWORD_START    = "RESET_PASSWORD_START"
export const RESET_PASSWORD_SUCCESS  = "RESET_PASSWORD_SUCCESS"
export const RESET_PASSWORD_ERROR    = "RESET_PASSWORD_ERROR"

// ── Affiliate & Coupons ───────────────────────────────────────────────────────
export const FETCH_AFFILIATE_LINKS_START      = "FETCH_AFFILIATE_LINKS_START"
export const FETCH_AFFILIATE_LINKS_SUCCESS    = "FETCH_AFFILIATE_LINKS_SUCCESS"
export const FETCH_AFFILIATE_LINKS_ERROR      = "FETCH_AFFILIATE_LINKS_ERROR"

export const CREATE_AFFILIATE_LINK_START      = "CREATE_AFFILIATE_LINK_START"
export const CREATE_AFFILIATE_LINK_SUCCESS    = "CREATE_AFFILIATE_LINK_SUCCESS"
export const CREATE_AFFILIATE_LINK_ERROR      = "CREATE_AFFILIATE_LINK_ERROR"

export const DELETE_AFFILIATE_LINK_START      = "DELETE_AFFILIATE_LINK_START"
export const DELETE_AFFILIATE_LINK_SUCCESS    = "DELETE_AFFILIATE_LINK_SUCCESS"
export const DELETE_AFFILIATE_LINK_ERROR      = "DELETE_AFFILIATE_LINK_ERROR"

export const FETCH_AFFILIATE_STATS_START      = "FETCH_AFFILIATE_STATS_START"
export const FETCH_AFFILIATE_STATS_SUCCESS    = "FETCH_AFFILIATE_STATS_SUCCESS"
export const FETCH_AFFILIATE_STATS_ERROR      = "FETCH_AFFILIATE_STATS_ERROR"

export const FETCH_COUPON_CODES_START         = "FETCH_COUPON_CODES_START"
export const FETCH_COUPON_CODES_SUCCESS       = "FETCH_COUPON_CODES_SUCCESS"
export const FETCH_COUPON_CODES_ERROR         = "FETCH_COUPON_CODES_ERROR"

export const CREATE_COUPON_CODE_START         = "CREATE_COUPON_CODE_START"
export const CREATE_COUPON_CODE_SUCCESS       = "CREATE_COUPON_CODE_SUCCESS"
export const CREATE_COUPON_CODE_ERROR         = "CREATE_COUPON_CODE_ERROR"

export const DELETE_COUPON_CODE_START         = "DELETE_COUPON_CODE_START"
export const DELETE_COUPON_CODE_SUCCESS       = "DELETE_COUPON_CODE_SUCCESS"
export const DELETE_COUPON_CODE_ERROR         = "DELETE_COUPON_CODE_ERROR"

// ── UGC Content Library & Licensing ───────────────────────────────────────────
export const FETCH_UGC_ASSETS_START        = "FETCH_UGC_ASSETS_START"
export const FETCH_UGC_ASSETS_SUCCESS      = "FETCH_UGC_ASSETS_SUCCESS"
export const FETCH_UGC_ASSETS_ERROR        = "FETCH_UGC_ASSETS_ERROR"

export const CREATE_UGC_ASSET_START        = "CREATE_UGC_ASSET_START"
export const CREATE_UGC_ASSET_SUCCESS      = "CREATE_UGC_ASSET_SUCCESS"
export const CREATE_UGC_ASSET_ERROR        = "CREATE_UGC_ASSET_ERROR"

export const UPDATE_UGC_ASSET_START        = "UPDATE_UGC_ASSET_START"
export const UPDATE_UGC_ASSET_SUCCESS      = "UPDATE_UGC_ASSET_SUCCESS"
export const UPDATE_UGC_ASSET_ERROR        = "UPDATE_UGC_ASSET_ERROR"

export const DELETE_UGC_ASSET_START        = "DELETE_UGC_ASSET_START"
export const DELETE_UGC_ASSET_SUCCESS      = "DELETE_UGC_ASSET_SUCCESS"
export const DELETE_UGC_ASSET_ERROR        = "DELETE_UGC_ASSET_ERROR"

export const IMPORT_UGC_ASSETS_START       = "IMPORT_UGC_ASSETS_START"
export const IMPORT_UGC_ASSETS_SUCCESS     = "IMPORT_UGC_ASSETS_SUCCESS"
export const IMPORT_UGC_ASSETS_ERROR       = "IMPORT_UGC_ASSETS_ERROR"

export const LOG_UGC_REUSE_START           = "LOG_UGC_REUSE_START"
export const LOG_UGC_REUSE_SUCCESS         = "LOG_UGC_REUSE_SUCCESS"
export const LOG_UGC_REUSE_ERROR           = "LOG_UGC_REUSE_ERROR"
